import { AddressFields } from '../components/pages/EditOrderPage';
import { useTranslation } from '../i18n/i18n';
import { useState } from 'react';

export const useErrors = () => {
	const [errors, setErrors] = useState<{ [key: string]: { valid: boolean; message?: string } }>({});
	const t = useTranslation().form;

	const validate = (
		value: string,
		name: AddressFields,
		{ pattern, required }: { pattern?: string; required: boolean }
	) => {
		setErrors((prev) => ({ ...prev, [name]: { valid: true } }));

		if (required && !value)
			setErrors((prev) => ({
				...prev,
				[name]: { valid: false, message: `${t[name]} ${t.required}` },
			}));

		if (pattern) {
			const regex = new RegExp(pattern);

			if (!regex.test(value))
				setErrors((prev) => ({
					...prev,
					[name]: { valid: false, message: `${t[name]} ${t.invalid}` },
				}));
		}
	};

	return { errors, setErrors, validate };
};
